<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-13 16:11:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/modifyphone/components/NewPhone/index.vue
-->
<template>
  <div class="phone">
    <van-field
      v-model="tel"
      type="tel"
      label="新手机号"
      placeholder="输入新手机号"
      @input="changePhone"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      tel: ""
    };
  },
  methods: {
    changePhone() {
      this.$emit("changePhone", this.tel);
    }
  }
};
</script>

<style lang="less" scoped>
.phone {
  margin: 16px 12px 0;
  ::v-deep .van-cell {
    background: #f6f7f8;
    border-radius: 20px;
  }
  ::v-deep .van-count-down {
    color: rgba(0, 0, 0, 0.38);
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  }
  ::v-deep .van-field__label {
    color: rgba(0, 0, 0, 0.87);
    font-size: 12px;
    font-weight: 500;
  }
}
</style>
